module.exports = __webpack_public_path__ + "img/diabete.78051c92.jpg";